
import { merge } from "lodash";
import { generateEndpoints, prefix } from "../helpers";

/**
 * This is the reource identifier
 * Everything will be under users.get, users.getAll, users.create, users.createAndSendEmail etc...
 */
const namespace = "repository-objects";

const nameSpace = merge({}, generateEndpoints(namespace), {
  get: {

  },
  post: {

  },
  put: {

  },
  delete: {
    deleteDocuments: (id) => [`${prefix}/preview/${namespace}/${id}`],
  }
})

export default nameSpace;
